module.exports = __webpack_public_path__ + "img/entia-portafolio-energia-carrusel-5.6a38668d.webp";